import React from 'react';
import { List } from '../components';

const App: React.FC = () => <List />;

export default App;
